module.exports = __webpack_public_path__ + "media/images/cereale-mobile-78a266ebb6cce00169a32078620e17a3.jpg";